export default {
    search: 'Search',
    cancel: 'Cancel',
    reset: 'Reset',
    OK: 'OK',
    noSearchResult: 'No search result',
    empty: 'Content is empty',
    workflow: 'processes',
};
